import React, { useState, useEffect } from "react";
import Deli_Logo from "../assets/Deli_Logo.svg";
import Button from "../components/Button";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth0 } from "@auth0/auth0-react";
import { getMLSList, updateUser } from "../utils/apiHandler";
import { jwtDecode } from "jwt-decode";
import LoadingSpinner from "../components/LoadingSpinner";
import SearchableDropdown from "../components/SearchableDropdown";
import PopUpMLSError from "../components/PopUpMLSError";

const Step1 = () => {
  const navigate = useNavigate();
  const { getIdTokenClaims, isAuthenticated, getAccessTokenSilently, getAccessTokenWithPopup, logout } =
    useAuth0();
  const [brokerName, setName] = useState("");
  const [brokerEmail, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedState, setSelectedState] = useState("");
  const [selectedMLS, setSelectedMLS] = useState("");
  const [enableMLS, setEnableMLS] = useState(false);
  const [states, setStates] = useState([]);
  const [MLS, setMLS] = useState([]);
  const [stateMLS, setStateMLS] = useState([]);
  const [selectedDataFeed, setSelectedDataFeed] = useState(null);
  const [MLSError, setMLSError] = useState(false)
  const [selectedRequiredBroker, setSelectedRequiredBroker] = useState(null);

  const FetchMLSList = async () => {
    var result = await getMLSList();
    if (result) {
      // Filter the result to only include Florida, Michigan, and Utah
      const filteredResult = Object.keys(result)
        .filter(state => state === 'Florida' || state === 'Michigan' || state === 'Utah')
        .reduce((obj, key) => {
          // Filter each state's MLS list to include only entries with a non-null datafeed
          const filteredMLS = result[key].filter(mls => mls.datafeed !== null);
  
          // Add the filtered MLS list for this state
          if (filteredMLS.length > 0) {
            obj[key] = filteredMLS;
          }
          return obj;
        }, {});
  
      // Set the filtered data
      setStateMLS(filteredResult);
  
      // Create the list of states with only Florida, Michigan, and Utah
      setStates(
        Object.keys(filteredResult).map((state) => ({ name: state, value: state }))
      );
    }
  };
  

  useEffect(() => {
    const authenticate = async () => {
      let idTokenClaims;
      let attempts = 0;

      // Attempt to refresh the token up to 3 times
      while (!idTokenClaims && attempts < 3) {
        await getAccessTokenSilently({ cacheMode: "off" });

        idTokenClaims = await getIdTokenClaims();
        attempts++;
      }

      if (idTokenClaims) {
        const idToken = idTokenClaims.__raw;
        const decodedToken = jwtDecode(idToken);

        if (decodedToken?.broker_verified) {
          navigate("/chat");
        }
      } else {
        console.error("Failed to refresh token after 3 attempts");
      }
    };

    authenticate();
  }, [getIdTokenClaims, isAuthenticated, getAccessTokenSilently, navigate]);

  useEffect(() => {
    FetchMLSList();
  }, [isAuthenticated]);

  if (!isAuthenticated && isLoading) {
    return <LoadingSpinner />; // Show the loading spinner when not authenticated and loading
  }

  const handleStateChange = (selectedValue) => {
    setSelectedState(selectedValue);
    setMLS(
      Object.values(stateMLS[selectedValue]).map((mls) => ({
        name: mls.name,
        value: mls.id,
        datafeed: mls.datafeed,
        require_broker : mls.require_broker
      }))
    );
    setEnableMLS(true);
  };

  const handleMLSChange = (selectedValue) => {
    setSelectedMLS(selectedValue);
    setIsLoading(false);
    
    let require_broker = MLS.find(
      (options) => options.value == selectedValue
    ).require_broker;

    let dataFeed = MLS.find(
      (options) => options.value == selectedValue
    ).datafeed;

    let body = {
      datafeed: dataFeed,
    };
    updateUser(getIdTokenClaims, body, getAccessTokenWithPopup, logout);
    setSelectedDataFeed(dataFeed);
    setSelectedRequiredBroker(require_broker);    
  };

  const handleContiueClick = async () => {
    setIsLoading(true);
    if (!brokerName || !brokerEmail || !selectedState || !selectedMLS) {
      toast.error("Please fill all fields");
      setIsLoading(false);
      return;
    }

    var nameParts = brokerName.split(' ');
    var firstName = nameParts[0];
    var lastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';

    let body = {
      first_name: firstName,
      last_name: ` ${lastName}`,
      accepted_terms: true,
      datafeed : selectedDataFeed
    }
    let response = await updateUser(getIdTokenClaims, body, false);
    

    if (response) {
      toast.success("Your information has been updated successfully.", {
        autoClose: 2000, // Toast will close after 3 seconds
        style: {
          fontSize: "12px",
          width: "100%",
        },
        onClose: () => {
          switch (selectedRequiredBroker) {
            case true:
              navigate("/step2");
              break
              case false:
              navigate("/stepspark");
              break
            default:
              setMLSError(true);
              break
          }
        },
      });
    }else{
      toast.error("We encounter a error, Please try again later.", {
        autoClose: 2000, // Toast will close after 3 seconds
        style: {
          fontSize: "12px",
          width: "100%",
        }
    })
    setIsLoading(false);
  }
}
  return (
    <div className="bg-gradient-custom m/d:[100vh] h-[100vh] relative">
      {MLSError ? (
          <div className="absolute top-0 left-0 backdrop-blur bg-white/30 w-full h-screen z-20"></div>
        ) : (
          ''
        )}
  
      {MLSError && (
        <div className="relative ">
          <PopUpMLSError setMLSError={setMLSError} />
        </div>
      )}

      <div className="h-full">
        <div className="flex justify-center overflow-y-auto relative h-[calc(100vh-55px)] 2xl:pt-14 lg:pt-8 pt-14">
          <div>
            <div className="flex justify-center items-center">
              <img src={Deli_Logo} alt=""  className="2xl:w-28"/>
            </div>
            <div className="2xl:mt-[4.5rem] mt-10">
              <div className="max-w-full px-5 mx-auto flex items-center justify-center flex-col">
                <h1 className="text-black tracking-tight font-semibold 2xl:text-8xl md:text-6xl leading-tight text-center text-5xl">
                  Talk with DELI
                </h1>
                <p className="text-[#344054] text-md tracking-tight 2xl:py-3 py-2 text-center">
                  Your helpful partner in searching for your clients dream home!
                </p>
              </div>
              <div className="max-w-full px-4 mx-auto 2xl:mt-4 mt-3">
                <div className="2xl:mb-6 mb-4">
                  <input
                    onChange={(e) => setName(e.target.value)}
                    className="w-full 2xl:py-3 py-2.5 px-4 2xl:text-md text-[0.9rem] rounded-full border-[#D0D5DD] border bg-[#FCFCFC] focus:outline-[#B0B5BD]"
                    type="text"
                    placeholder="Full name"
                  />
                  <input
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full 2xl:py-3 py-2.5 2xl:mt-6 mt-4 px-4 2xl:text-md text-[0.9rem] rounded-full border-[#D0D5DD] border bg-[#FCFCFC] focus:outline-[#B0B5BD]"
                    type="email"
                    placeholder="What should we call you?"
                  />
                  <SearchableDropdown
                    options={states}
                    onChange={handleStateChange}
                    placeholder="Select your state"
                    disabled={false}
                  />

                  <SearchableDropdown
                    options={MLS}
                    onChange={handleMLSChange}
                    placeholder="Search MLS"
                    disabled={!enableMLS}
                  />
                </div>
                <Button
                  text={isLoading ? "Loading ..." : "Continue"}
                  bgColor={isLoading ? "bg-[#9199a7]" : "bg-[#0062ff]"}
                  textColor="text-white"
                  onClick={handleContiueClick}
                  disabled={isLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step1;
